import React, {useCallback, useEffect, useState} from 'react';
import CumulativeVolumeReportChart from './component/CumulativeVolumeReportChart';
import DeliveryReportDataTable from './component/DeliveryReportDataTable';
import {TotalCumulativeVolumeReportType} from './intakeAuditTypes';

interface CustodianType {
  custodianName: string;
  receivedDate: string;
  emailCompressed: string;
  externallyProcessed: string;
  otherData: string;
  subTotal: string;
  id?: string;
}

interface ByDeliveryTabProps {
  totalCumulativeReceivedVolume: TotalCumulativeVolumeReportType;
  custodianData: CustodianType[];
  totalRecordsCount?: number;
  onPagePropsChange?: (itemsPerPage: number, currentPage: number) => void;
  onRefresh?: () => void;
  isChartFailed?: boolean;
  isChartLoading?: boolean;
  size?: number;
}

const ByDeliveryTab: React.FC<ByDeliveryTabProps> = ({
  totalCumulativeReceivedVolume,
  custodianData,
  totalRecordsCount,
  onPagePropsChange,
  onRefresh,
  isChartFailed,
  isChartLoading,
  size,
}) => {
  const [hoverDeliveryData, setHoverDeliveryData] =
    useState<CustodianType | null>(null);

  useEffect(() => {
    setHoverDeliveryData(null);
  }, [totalRecordsCount, custodianData]);

  const onDeliveryRowHoverEvent = useCallback((event: CustodianType | null) => {
    setHoverDeliveryData(event);
  }, []);
  return (
    <>
      <CumulativeVolumeReportChart
        custodianData={custodianData}
        totalCumulativeReceivedVolume={totalCumulativeReceivedVolume}
        hoverCustodian={hoverDeliveryData}
        onRefresh={onRefresh}
        isChartFailed={isChartFailed}
        isChartLoading={isChartLoading}
      />
      <DeliveryReportDataTable
        deliveryData={custodianData}
        totalCumulativeReceivedVolume={totalCumulativeReceivedVolume}
        onDeliveryRowHoverEvent={onDeliveryRowHoverEvent}
        onPagePropsChange={onPagePropsChange}
        totalRecordsCount={totalRecordsCount}
        onRefresh={onRefresh}
        isChartFailed={isChartFailed}
        isChartLoading={isChartLoading}
        size={size}
      />
    </>
  );
};

export default ByDeliveryTab;
